import { render, staticRenderFns } from "./RecipientsField.vue?vue&type=template&id=a8480396&scoped=true"
import script from "./RecipientsField.vue?vue&type=script&lang=js"
export * from "./RecipientsField.vue?vue&type=script&lang=js"
import style0 from "./RecipientsField.vue?vue&type=style&index=0&id=a8480396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8480396",
  null
  
)

export default component.exports